import {
    alldone,
    forcestopnow,
    fps,
    ico_he,
    picture_convert,
    reels_lenghts,
    reels_pos,
    round_running,
    server_result,
    set_rotated,
    rotated,
    in_free_spins,
    server_config,
    behavior_config,
    set_forcestopnow,
    in_free_spins_total,
    set_inanim,
    inwincount,
    set_inwincount,
    big_win,
    he,
    in_free_spins_pos,
    inmoneyadd,
    set_inmoneyadd,
    inbigwin,
    set_inbigwin,
    states,
    set_in_free_spins,
    set_in_free_spins_pos,
    inc_in_free_spins_total, he_scale, multi, wi_scale, set_in_free_spins_total,
    inanim, wi, set_server_result
} from "../framework/src/engine/madnes/madnes_variables";

import * as MV from "../framework/src/engine/madnes/madnes_variables";

import {
    madnes_get_currtime,
    madnes_new_round,
    madnes_win_anim_reset,
    madnes_win_anim_skip,
    madnes_start_freespins,
    madnes_money_to_coin,
    win,
    bet,
    madnes_end_round,
    madnes_end_freespins,
    madnes_set_win,
    madnes_add_win, madnes_reels_start, madnes_reels_stop, madnes_is_in_autostart
} from "../framework/src/engine/madnes/madnes";

import {
    madnes_audio_continue,
    madnes_audio_fade_out,
    madnes_audio_fade_to,
    madnes_audio_get_volume,
    madnes_audio_is_playing,
    madnes_audio_loop,
    madnes_audio_pause,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";

import {
    madnes_anim_add, madnes_anim_add_oncomplete,
    madnes_anim_is_playing,
    madnes_anim_loop,
    madnes_anim_play, madnes_show_money
} from "../framework/src/engine/madnes/madnes_anims";

import {
    madnes_get_alpha,
    madnes_get_pos_y,
    madnes_get_texture,
    madnes_set_alpha, madnes_set_angle, madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_x, madnes_set_pos_y, madnes_set_scale,
    madnes_set_texture
} from "../framework/src/engine/madnes/madnes_object";

import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";

import {STATES} from "../framework/src/states/states";
import AddResult from "../framework/src/connect/result/AddResult";

import {
    madnes_add_to_render,
    madnes_alpha_to,
    madnes_rem_from_render,
    madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {cylinder_pos, icons, last_symbol, symbols} from "./wanted_config";
import {wanted_print_reels} from "./wanted_core_printer";
import {insaloon, set_insaloon, wanted_saloon_start} from "./wanted_saloon";
import {freepanelpos, set_freepanelpos} from "./wanted_reels";
import {
    wanted_freespin_hide,
    wanted_freespin_show,
    wanted_scatter_scale_anim,
    wanted_show_line,
    wanted_show_win_sum_animated,
    wanted_show_win_sum_start,
    wanted_bullet_show,
    wanted_bullets_hide,
    wanted_hide_lines,
    wanted_boom_start,
    wanted_shake_desk,
    set_wanted_snake_desk_step,
    set_wanted_snake_desk_pos,
    set_wanted_snake_desk_dir, wanted_boom_end
} from "./wanted_anims";

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var autospin_force = false;
var autospin_force_enabled = false;


export function wanted_rotate_run() {
    if(round_running) //waiting for end round
    {
        return;
    }

    wanted_rotate_start();
}

function wanted_rotate_start()
{
    if(inanim == 1)
    {
        return;
    }

    autospin_force_enabled = false;
    autospin_force = false;

    if(rotated == 0)
    {
        // madnes_on_round_start();

        if(autospin_rot_lock)
        {
            clearTimeout(autospin_rot_lock_timer);
            autospin_rot_lock_timer = setTimeout(wanted_rotate_start, ( 1000 / fps ) * 2 );
            return;
        }

        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i in server_config.logic.reels)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        // if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        // {
        //     autostart = autostart*1-1;
        // }
        set_rotated(1); //rotated = 1;
        autospin_rot_lock = true;
        startposin = JSON.parse(JSON.stringify(stopposin));

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        if(!in_free_spins)
        {
            // madnes_new_round();
            // force_res = "";

            wanted_freespin_hide(1);
            wanted_freespin_hide(2);
            wanted_freespin_hide(3);
            wanted_freespin_hide(4);
            wanted_freespin_hide(5);
        }

        can_stop = 0;

        rotate_start_time = madnes_get_currtime();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0); // forcestopnow = 0;
        scatters_runned = false;

        //madnes_audio_play("REEL_START");

        madnes_add_to_render(wanted_rotate_start);
        madnes_reels_start();
    }
    else
    {
        var time = madnes_get_currtime() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc

            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }

        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            madnes_audio_loop("REEL_BG");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = madnes_get_currtime();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    if(behavior_config.reel.spin.motionBlur == 1)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S0", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S1", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S2", "blur");

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "blur");
                        }

                    }
                }

                rotate_start_in_accel = 1;

                // wanted_rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = madnes_get_currtime();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;

            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;

                madnes_rem_from_render(wanted_rotate_start);
                madnes_add_to_render(wanted_rotate_control);
            }
        }

        wanted_print_reels();
    }
}

export let stopposin = new Array();
export let startposin = new Array();

export let stopposin_round = new Array();
export let stopping = new Array();

export let stopposin_old = new Array();
export let stoppostime_br = new Array();
export let stoppostime = new Array();

var stoppos_swing = new Array();

var scatters = 0;
var saloons = 0;
var all_set_for_stop = 0;

export var result_lock = 0;

var scatters_runned = false;
function wanted_rotate_control()
{
    var time = madnes_get_currtime();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }

        scatters = 0;
        saloons = 0;

    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow === 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
                    }
                }

                var sc_tmp = 0;
                var sa_tmp = 0;

                var add_tmp_sc = 0;
                var add_tmp_sa = 0;

                for(var j = 0; j < i; j++)
                {
                    for(var spos = 0; spos <= 2; spos++)
                    {
                        if(server_result.result.reelMatrix[0][j][spos] == 8)
                        {
                            sa_tmp++;
                        }
                        else if(server_result.result.reelMatrix[0][j][spos] == 9)
                        {
                            sc_tmp++
                        }
                    }
                    if(sa_tmp >= 2)
                    {
                        add_tmp_sa++;
                    }
                    if(sc_tmp >= 2)
                    {
                        add_tmp_sc++;
                    }
                }

                if(sa_tmp >= 2 || sc_tmp >= 2)
                {
                    if(typeof behavior_config.reel.spin.scatterDuration != "undefined")
                    {
                        var add = add_tmp_sc;
                        if(add_tmp_sa > add)
                        {
                            add = add_tmp_sa;
                        }
                        add = add - 1;
                        var tmp_dur = behavior_config.reel.spin.scatterDuration * 1 + behavior_config.reel.spin.scatterDelay * add;
                        stopposin[i] += tmp_dur * 1;
                    }
                    else
                    {
                        stopposin[i] += 20;
                    }
                }

                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );

            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    if(!in_free_spins)
                    {
                        wanted_freespin_hide(i + 1);
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {
                        wanted_control_show_spin(i);
                        wanted_control_stop_sound(i);

                        for(var spos = 0; spos <= 2; spos++)
                        {
                            if(server_result.result.reelMatrix[0][i][spos] == 8)
                            {
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "nowin")
                                saloons++;
                            }
                            else if(server_result.result.reelMatrix[0][i][spos] == 9)
                            {
                                // SCATTER
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                                wanted_scatter_scale_anim(i, 'S'+(2-spos), 0);
                                scatters++;
                            }
                            else
                            {
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                            }

                            if(
                                (
                                    scatters == 2 ||
                                    saloons == 2
                                )
                                &&
                                scatters_runned == false &&
                                forcestopnow == 0 &&
                                i < 4
                            )
                            {
                                scatters_runned = true;
                                for(var ii = i+2; ii <= 5; ii++)
                                {
                                    if(forcestopnow == 0)
                                    {
                                        wanted_freespin_show(ii);
                                    }
                                }
                                madnes_audio_play("reel_search");
                            }
                        }

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
                        }
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;
                //var mt = behavior_config.reel.brake.moveTime;
                var mt = behavior_config.reel.brake.moveBackTime;


                var cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        madnes_audio_stop("REEL_BG");
                        madnes_audio_stop("reel_search");
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        madnes_audio_stop("REEL_BG");
                        madnes_audio_stop("reel_search");
                    }

                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );

                }
                else
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        madnes_audio_stop("REEL_BG");
                        madnes_audio_stop("reel_search");
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        alldone[i] = 1;
                    }
                }

            }
        }

        if(alldone.indexOf(0) == -1)
        {
            madnes_audio_stop("REEL_BG");
            madnes_audio_stop("reel_search");

            //madnes_hide_stop();

            setTimeout(wanted_result_control, 100);
            madnes_rem_from_render(wanted_rotate_control);
            madnes_reels_stop();
        }

    }

    wanted_print_reels();
}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var wanted_rotate_stop_loading = 0;
export function wanted_rotate_stop()
{
    if(rotated != 0 && wanted_rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        wanted_rotate_stop_loading = 1;
        var poss = 0;
        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {

                if(picture_convert[server_result.result.reelMatrix[0][i][j]] == "symbol_Bonus")
                {
                    madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), picture_convert[server_result.result.reelMatrix[0][i][j]]);
                    for(var anim in icons[picture_convert[server_result.result.reelMatrix[0][i][j]]])
                    {
                        madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), anim, icons[picture_convert[server_result.result.reelMatrix[0][i][j]]][anim]);
                    }

                }
                else
                {
                    madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), picture_convert[server_result.result.reelMatrix[0][i][j]] + "_blur");

                    madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), "stop", [1]);
                    madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), "blur", [0]);
                }

                if(behavior_config.reel.spin.motionBlur == 1)
                {
                    madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "blur");
                }
                else
                {
                    madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "stop");
                }
            }
        }

        setTimeout(function() {
            all_set_for_stop = 1;
            wanted_rotate_stop_loading = 0;
        }, (1000 / ( fps ) ) * poss);
        set_rotated(0); // rotated = 0;
    }
}
var autospin_rot_lock = false;
var autospin_rot_lock_timer = null;

function rotate_release()
{
    if(autospin_force_enabled)
    {
        autospin_force = true;
    }

    autospin_force_enabled = false;
}

function forcestop_press()
{
    autospin_force = false;
}

function wanted_control_show_spin(reel)
{
    if(reel == 3 && !in_free_spins && !madnes_is_in_autostart())
    {
        states.setState(STATES.FORCESPIN);
        // autospin_force_enabled = true;
        // madnes_show_spin();
    }
}

function wanted_control_stop_sound(reel)
{
    madnes_audio_play("REEL_STOP_"+(reel+1));

    var up_sym = server_result.result.reelMatrix[0][reel][0];
    var mi_sym = server_result.result.reelMatrix[0][reel][1];
    var dn_sym = server_result.result.reelMatrix[0][reel][2];

    if(up_sym == 9 || mi_sym == 9 || dn_sym == 9)
    {
        madnes_audio_play("SCATTER_SND");
        //madnes_audio_play("SCATTER_SND_"+(reel+1));// ODEBRANO 20170524
    }

    if(
        up_sym == 7  || mi_sym == 7  || dn_sym == 7 ||
        up_sym == 10 || mi_sym == 10 || dn_sym == 10
    )
    {
        //madnes_audio_play("WILD_SND_"+(reel+1)); // ODEBRANO 20170524
    }

    if(up_sym == 8 || mi_sym == 8 || dn_sym == 8)
    {
        madnes_audio_play("SL_SND_"+(reel+1));
    }
}

// Zacatek kontroly vyher
export var result_control_pos = 0;
export function set_result_control_pos(pos) {
    result_control_pos = pos;
}

function wanted_result_control()
{
    //madnes_hide_spin();
    set_inanim(true); //inanim = 1;
    result_control_pos = 0;

    wanted_result_control_part();
}

function wanted_get_linewins_win_sum(result, calcMultiplier)
{
    var round_win_sum = 0;

    if(result && result['lineWins'] && result['lineWins'].length > 0)
    {
        for(var i = 0; i < result['lineWins'].length; i++)
        {
            if(result['lineWins'][i]['win'] && Number(result['lineWins'][i]['win']) > 0)
            {
                var round_multip = (calcMultiplier && result['lineWins'][i]['multiplier']) ? result['lineWins'][i]['multiplier'] : 1;
                round_win_sum += result['lineWins'][i]['win'] * round_multip;
            }
        }
    }

    return round_win_sum;
}

function wanted_get_round_win_sum(round_id, results, calcMultiplier)
{
    var lines_win_sum = 0;

    if(results[round_id] && results[round_id]['result'])
    {
        lines_win_sum = wanted_get_linewins_win_sum(results[round_id]['result'], calcMultiplier);
    }

    return lines_win_sum;
};

function wanted_results_win_sum(toIndex, results, calcMultiplier)
{
    var results_sum = 0;

    for(var i = 0; i <= toIndex; i++) {
        results_sum += wanted_get_round_win_sum(i, results, calcMultiplier);
    }

    return results_sum;
}

// kontrola vyhry na aktualni pozici
export async function wanted_result_control_part()
{
    if(server_result.result.lineWins == null)
    {
        if(
            behavior_config.sound.background.freeSpinsBackground != madnes_audio_get_volume('BACKGROUND_FS') &&
            madnes_audio_get_volume('BACKGROUND_FS') != 0
        )
        {
            madnes_audio_fade_to('BACKGROUND_FS', behavior_config.sound.background.freeSpinsBackground, 400);
        }

        madnes_win_anim_reset();
        if(in_free_spins)
        {
            setTimeout(wanted_control_freespins, 500);
        }
        else
        {
            wanted_money_add_control();
        }
        autospin_rot_lock = false;
        return;
    }
    if(server_result.result.lineWins[result_control_pos] == null)
    {
        if(
            behavior_config.sound.background.freeSpinsBackground != madnes_audio_get_volume('BACKGROUND_FS') &&
            madnes_audio_get_volume('BACKGROUND_FS') != 0
        )
        {
            madnes_audio_fade_to('BACKGROUND_FS', behavior_config.sound.background.freeSpinsBackground, 400);
        }

        madnes_win_anim_reset();
        for(var i = 0; i < 5; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }
        if(in_free_spins)
        {
            setTimeout(wanted_control_freespins, 500);
        }
        else
        {
            wanted_money_add_control();
        }

        set_inwincount(false); //inwincount = false;
        autospin_rot_lock = false;
        return;
    }
    else
    {
        states.setState(STATES.SKIP);
        // madnes_hide_stop();
        clearTimeout(autospin_rot_lock_timer);

        if(madnes_win_anim_skip())
        {
            if(
                server_result.result.lineWins[result_control_pos].type == "wild" ||
                server_result.result.lineWins[result_control_pos].type == "normal"
            )
            {
                await madnes_add_win(server_result.result.lineWins[result_control_pos].win * 1); //win = win * 1 + server_result.result.lineWins[result_control_pos].win * 1;
                result_control_pos++;
                wanted_result_control_part();
            }
            else
            {
                //console.log(server_result.result.lineWins[result_control_pos]);
                wanted_result_control_part_proc(server_result.result.lineWins[result_control_pos])
            }
        }
        else
        {
            wanted_result_control_part_proc(server_result.result.lineWins[result_control_pos])
        }
    }
}

let fsCurrent = 0;
let fsTotal = 0;
let fsAdd = 0;

// kontrola aktualni vyhry
function wanted_result_control_part_proc(win_set)
{
    // (Caru -> zvuk) -> zabarvit -> otocit -> prostrelit -> otocit zpet -> posunout
    set_inwincount(true); // inwincount = true;

    var linenum = 0;
    if(win_set.line != null && typeof win_set.line != "undefined" && win_set.line >= 0 && win_set.line <= 9)
    {
        linenum = win_set.line + 1;
    }

    if(linenum != 0)
    {
        if(
            behavior_config.sound.background.freeSpinsBackground / 2 != madnes_audio_get_volume('BACKGROUND_FS') &&
            madnes_audio_get_volume('BACKGROUND_FS') != 0
        )
        {
            madnes_audio_fade_to('BACKGROUND_FS', behavior_config.sound.background.freeSpinsBackground / 2, 400);
        }

        madnes_audio_pause('BACKGROUND');
        wanted_show_line(linenum);

        // madnes_win_anim_add();

        var symbol = picture_convert[win_set.symbol];
        var symbol_count = win_set.position.length;
        symbol = symbol.split("_");
        symbol = symbol[1];

        switch(symbol.toUpperCase())
        {
            case "COLTS": symbol = "PISTOLS"; break;
            case "DOLLARS": symbol = "CASH"; break;
            case "WHISKY": symbol = "WHISKEY"; break;
            case "BANDIT-1": symbol = "BANDITS"; break;
            case "BANDIT-2": symbol = "BANDITS"; break;
            case "BANDIT-3": symbol = "BANDITS"; break;
            case "WILD-1": symbol = "WILD"; break;
            case "WILD-2": symbol = "WILD"; break;
        }

        var audio_name = "WIN_LINE_"+symbol.toUpperCase()+"_"+symbol_count;

        madnes_audio_play(audio_name);

        wanted_result_control_part_proc_rem_color(win_set);
    }
    else if(win_set.type == "scatter")
    {
        madnes_start_freespins();

        fsCurrent = MV.freespins.getFreeSpinNumber();
        MV.game.freespins.run(new AddResult(server_result));
        fsTotal = MV.freespins.getFreeSpinNumber();
        fsAdd = 0;

        if(
            behavior_config.sound.background.freeSpinsBackground * 0.6 != madnes_audio_get_volume('BACKGROUND_FS') &&
            madnes_audio_get_volume('BACKGROUND_FS') != 0
        )
        {
            madnes_audio_fade_to('BACKGROUND_FS', behavior_config.sound.background.freeSpinsBackground * 0.6, 200);
        }

        set_inwincount(false); // inwincount = false;
        var audio_name = "WIN_LINE_SCATTER_" + win_set.position.length;
        madnes_audio_play(audio_name);

        for(var i = 0; i < 5; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }

        for(var i = 0; i < 5; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                var is_win = 0;
                for(var wset in win_set.position)
                {
                    if(win_set.position[wset][0] == i && win_set.position[wset][1] == j)
                    {
                        madnes_set_texture("reels_bufer_" + i + "_TMP" + ( 2 - j ), "symbol_Scatter");
                        for(var anim in icons["symbol_Scatter"])
                        {
                            madnes_anim_add("reels_bufer_" + i + "_TMP" + ( 2 - j ), anim, icons["symbol_Scatter"][anim]);
                        }

                        if(madnes_get_pos_y("reels_bufer_" + i + "_S" + ( 2 - j )) > 0)
                        {
                            madnes_set_pos_y("reels_bufer_" + i + "_TMP" + ( 2 - j ), madnes_get_pos_y("reels_bufer_" + i + "_S" + ( 2 - j )));
                            madnes_set_pos_y("reels_bufer_" + i + "_S" + ( 2 - j ), -9999);
                        }

                        madnes_anim_play("reels_bufer_" + i + "_TMP" + ( 2 - j ), "anim");
                    }
                }
            }
        }

        if(!in_free_spins && fsCurrent == 0 /*in_free_spins_total == 0*/)
        {
            madnes_audio_pause('BACKGROUND');
            setTimeout(function() {
                madnes_audio_loop('BACKGROUND_FS');
            }, 1500);

        }

        if(fsCurrent*1 != fsTotal)
        {
            setTimeout(wanted_add_free_spins, 800);
            return;
        }

        if(!in_free_spins)
        {
            set_in_free_spins(true); // in_free_spins = true;
            // madnes_add_balance_to_money_lock = true;
            // in_free_spins_pos = 0;
            madnes_set_text("free1", 0 /*in_free_spins_pos.toString()*/);
        }

        setTimeout(wanted_control_freespins, in_free_spins ? 100 : 2000);

    }
    else if(win_set['type'] == "bonus")
    {
        set_inwincount(true); // inwincount = false;

        if(insaloon)
        {
            return;
        }

        set_inanim(1); //inanim = 1;
        set_insaloon(true); //insaloon = 1;

        var audio_name = "WIN_LINE_SALOON_"+win_set.position.length;
        madnes_audio_play(audio_name);

        for(var i = 0; i < 5; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }

        for(var i = 0; i < 5; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                var is_win = 0;
                for(var wset in win_set.position)
                {
                    if(win_set.position[wset][0] == i && win_set.position[wset][1] == j)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "win");
                    }
                }
            }
        }

        wanted_print_reels();

        setTimeout(wanted_saloon_start, 2000);

    }
    else
    {
        wanted_hide_lines();
        result_control_pos++;
        wanted_result_control_part();
        if(in_free_spins)
        {
            wanted_control_freespins();
        }
    }
}

var wanted_fs_whip3_count = 0;
function wanted_fs_whip3()
{
    wanted_fs_whip3_count = 0;
    wanted_fs_whip3_control();
}

function wanted_fs_whip3_control()
{
    if(!madnes_audio_is_playing("FS_whip"))
    {
        wanted_fs_whip3_count++;
        madnes_audio_play("FS_whip");
        setTimeout(function(){
            madnes_audio_fade_out("FS_whip", 200);
        }, 400);
        setTimeout(wanted_fs_whip3_control, 1000 / fps);
    }

    if(wanted_fs_whip3_count < 3)
    {
        setTimeout(wanted_fs_whip3_control, 1000 / fps);
    }
}

// Vstup do freespinu + animace pridani spinu
var in_free_spins_tmp = false;
function wanted_add_free_spins()
{
    if(!in_free_spins)
    {
        wanted_freespin_show(1);
        wanted_freespin_show(2);
        wanted_freespin_show(3);
        wanted_freespin_show(4);
        wanted_freespin_show(5);

        if(freepanelpos > -10)
        {
            set_freepanelpos(freepanelpos * 1 - 10); // freepanelpos = freepanelpos * 1 - 10;
            madnes_set_pos_y("table_free-spins", he + freepanelpos);
            madnes_set_pos_y("free1", he + freepanelpos);
            madnes_set_pos_y("free2", he + freepanelpos);
            setTimeout(wanted_add_free_spins, 1000 / fps);
            return;
        }

        set_freepanelpos(-10); //freepanelpos = -10;

        set_in_free_spins(true); // in_free_spins = true;
        // madnes_add_balance_to_money_lock = true;
        set_in_free_spins_pos(0); // in_free_spins_pos = 0;
        madnes_set_text("free1", 0); //madnes_set_text("free1", in_free_spins_pos.toString());
        in_free_spins_tmp = true;

        //madnes_audio_play("WANTED_FS_DOPLNEK");// ODEBRANO 20170524
        wanted_fs_whip3();

        madnes_set_pos("freespins_start", wi / 2, he / 2);
        madnes_alpha_to("freespins_start", 1, 200);
        madnes_scale_to("freespins_start", 1.2, 1.2, 260, function()
        {
            madnes_scale_to("freespins_start", 1.0, 1.0, 300, function()
            {
                madnes_scale_to("freespins_start", 1.2, 1.2, 260, function()
                {
                    madnes_scale_to("freespins_start", 1.0, 1.0, 300, function()
                    {
                        madnes_scale_to("freespins_start", 1.2, 1.2, 260, function()
                        {
                            madnes_alpha_to("freespins_start", 0, 300);
                            madnes_scale_to("freespins_start", 1.0, 1.0, 300, function()
                            {
                                madnes_set_pos("freespins_start", -9999, -9999);
                                wanted_add_free_spins();
                            })
                        })
                    })
                })
            })
        });

        return;
    }

    if((fsAdd + fsCurrent) != fsTotal)
    {
        autospin_rot_lock = false;

        // if(in_free_spins_total == 0)
        // {
        //     var end_spin = madnes_get_cookie("lfspos_" + server_config['session_id']);
        //
        //     if(typeof end_spin == "undefined")
        //     {
        //         end_spin = 0;
        //     }
        //
        //     in_free_spins_pos = end_spin;
        //     madnes_set_text("free1", in_free_spins_pos.toString());
        //
        //     // if(end_spin > 0)
        //     // {
        //     //     win = wanted_results_win_sum(end_spin - 1, server_result.result.freeSpinResults, false) + server_result.result.win;
        //     //     server_result.result.freeSpinNumber = server_result.result.freeSpinResults[end_spin - 1].result.freeSpinNumber;
        //     // }
        // }

        fsAdd++;

        madnes_set_text("free1", MV.freespins.getRoundNumber());

        madnes_audio_play("bonus_FreeSpins_Counter");
        //inc_in_free_spins_total(); //in_free_spins_total++;
        //inanim = 1;
        madnes_set_text("free2", (fsCurrent + fsAdd));

        setTimeout(function()
        {
            wanted_add_free_spins();
        }, 120);
    }
    else
    {
        if(!in_free_spins || in_free_spins_tmp)
        {
            in_free_spins_tmp = false;
            for(var i = 0; i < 5; i++)
            {
                for(var j = 0; j < 3; j++)
                {
                    madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
                }
            }
            /*
            madnes_audio_pause('BACKGROUND');
            madnes_audio_loop('BACKGROUND_FS');
            */
        }

        if(MV.game.freespins.isSkipping()) {
            madnes_set_win(MV.game.freespins.getRoundWinByLines());
        }

        setTimeout(function() {
            wanted_control_freespins();
        }, 1000);
    }
}

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

async function wanted_control_freespins()
{
    let server_result_tmp = JSON.parse(JSON.stringify(server_result));
    let pos = MV.game.freespins.getRoundIndex() + 1;

    if(server_result.result.freeSpinResults[pos] == null || typeof server_result.result.freeSpinResults[pos] == "undefined")
    {
        // madnes_end_freespins();

        if(freepanelpos < 200)
        {
            set_freepanelpos(freepanelpos * 1 + 10); //freepanelpos = freepanelpos * 1 + 10;
            madnes_set_pos_y("table_free-spins", he + freepanelpos);
            madnes_set_pos_y("free1", he + freepanelpos);
            madnes_set_pos_y("free2", he + freepanelpos);
            setTimeout(wanted_control_freespins, 1000 / fps);
            return;
        }

        if(
            behavior_config.sound.background.freeSpinsBackground != madnes_audio_get_volume('BACKGROUND_FS') &&
            madnes_audio_get_volume('BACKGROUND_FS') != 0
        )
        {
            madnes_audio_fade_to('BACKGROUND_FS', behavior_config.sound.background.freeSpinsBackground, 400);
        }

        set_freepanelpos(200); //freepanelpos = 200;

        set_in_free_spins(false); //in_free_spins = false;

        // var cname = "lfspos_" + server_config.session_id;
        // madnes_set_cookie(cname, "0");

        // madnes_add_balance_to_money_lock = false;
        in_free_spins_tmp = false;
        // in_free_spins_pos = 0;
        madnes_set_text("free1", 0 /*MV.game.freespins.getRoundIndex() + 1*/ /*in_free_spins_pos.toString()*/);
        // in_free_spins_total = 0;
        madnes_set_text("free2", 0 /*MV.game.freespins.getFreeSpinNumber()*/ /*in_free_spins_total.toString()*/);

        wanted_freespin_hide(1);
        wanted_freespin_hide(2);
        wanted_freespin_hide(3);
        wanted_freespin_hide(4);
        wanted_freespin_hide(5);

        madnes_audio_stop('BACKGROUND_FS');

        /*
        console.log("5");
        madnes_end_round();
        */

        wanted_money_add_control();
    }
    else
    {

        if(
            behavior_config.sound.background.freeSpinsBackground != madnes_audio_get_volume('BACKGROUND_FS') &&
            madnes_audio_get_volume('BACKGROUND_FS') != 0
        )
        {
            madnes_audio_fade_to('BACKGROUND_FS', behavior_config.sound.background.freeSpinsBackground, 400);
        }

        result_lock = 1;

        set_rotated(false); //rotated = 0;

        wanted_freespin_show(1);
        wanted_freespin_show(2);
        wanted_freespin_show(3);
        wanted_freespin_show(4);
        wanted_freespin_show(5);

        set_inanim(0); // inanim = 0;

        madnes_set_text("free1", pos + 1);

        await madnes_end_round();

        setTimeout(() => {
            set_server_result(server_result_tmp);

            server_result.result.reelMatrix = server_result.result.freeSpinResults[pos].result.reelMatrix;
            server_result.result.freeSpinNumber = server_result.result.freeSpinResults[pos].result.freeSpinNumber;
            server_result.result.lineWins = server_result.result.freeSpinResults[pos].result.lineWins;
            server_result.result.gameSpecifics = server_result.result.freeSpinResults[pos].result.gameSpecifics;

            result_lock = 0;

        }, 500);
    }
}

// Zasednout nevyherni symboly pro zvirazneni vyhry
function wanted_result_control_part_proc_rem_color(win_set)
{
    // Caru -> zvuk -> (zabarvit) -> otocit -> prostrelit -> otocit zpet -> posunout

    if(typeof win_set.multiplier == "undefined")
    {
        win_set.multiplier = 1;
    }

    //win = win * 1 + win_set.win * win_set.multiplier;
    madnes_add_win(win_set.win * 1); //win = win * 1 + win_set.win * 1;

    for(var i = 0; i < 5; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            var is_win = 0;
            for(var wset in win_set.position)
            {
                if(win_set.position[wset][0] == i && win_set.position[wset][1] == j)
                {
                    is_win = 1;
                }
            }
            if(is_win == 0)
            {
                if(madnes_get_alpha("reels_bufer_" + i + "_S" + ( 2 - j )) == 1)
                {
                    var step = 50;
                    var del = 50;
                    var alpha = 1;
                    var inpos = 0;
                    while(alpha > 0.4)
                    {
                        (function(i, j) {
                            setTimeout(function() {
                                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), alpha);
                            }, inpos * step)
                        } (i, j));

                        inpos++;
                        alpha -= step/1000;
                    }
                }
            }
            else
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }
    }

    wanted_result_control_part_proc_trn(win_set);
}

// Otoceni wild symbolu
function wanted_result_control_part_proc_trn(win_set)
{
    // Caru -> zvuk -> zabarvit -> (otocit) -> prostrelit -> otocit zpet -> posunout
    if(win_set.type == "wild")
    {
        var wilds = new Array();
        for(var wld in server_result.result.gameSpecifics.wildPositions)
        {
            var x_tmp = server_result.result.gameSpecifics.wildPositions[wld][0];
            var y_tmp = server_result.result.gameSpecifics.wildPositions[wld][1];
            if(wilds[x_tmp] == null)
            {
                wilds[x_tmp] = new Array();
            }
            wilds[x_tmp][wilds[x_tmp].length] = y_tmp;
        }

        for(var pos in win_set.position)
        {
            if(wilds[win_set.position[pos][0]] != null)
            {
                if(wilds[win_set.position[pos][0]].indexOf(win_set.position[pos][1]) != -1)
                {
                    var symbol = picture_convert[win_set.symbol];
                    symbol = symbol.split("_");
                    symbol = symbol[1];

                    var texture1 = madnes_get_texture("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ));
                    texture1 = texture1.replace("_blur", "");

                    madnes_set_texture("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), texture1);
                    for(var anim in icons[texture1])
                    {
                        madnes_anim_add("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), anim, icons[texture1][anim]);

                        if(anim == "flip")
                        {
                            madnes_anim_add_oncomplete(
                                "reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ),
                                wanted_anim_flip.bind(this, symbol, win_set.position[pos][0], ( 2 - win_set.position[pos][1] ) )
                            );
                        }

                    }

                    if(madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )) > 0)
                    {
                        madnes_set_pos_y("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )));
                        madnes_set_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ), -9999);
                    }


                    madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "flip");

                    //madnes_audio_play("WILD_FLIP");// ODEBRANO 20170524
                }
            }
        }
        setTimeout(function() {
            wanted_result_control_part_proc_shoot(win_set);
        }, 800);
    }
    else if(win_set.type == "normal" && (win_set.symbol == 7 || win_set.symbol == 9))
    {
        for(var pos in win_set.position)
        {
            var symbol = madnes_get_texture("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ));
            symbol = symbol.replace("_blur", "");
            madnes_set_texture("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), symbol);
            for(var anim in icons[symbol])
            {
                madnes_anim_add("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), anim, icons[symbol][anim]);
            }

            if(madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )) > 0)
            {
                madnes_set_pos_y(
                    "reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ),
                    madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ))
                );
                madnes_set_pos_y(
                    "reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ),
                    -9999
                );
            }

            madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "anim");


            //madnes_audio_play("WILD_FLIP");// ODEBRANO 20170524

        }
        setTimeout(function() {
            wanted_result_control_part_proc_shoot(win_set);
        }, 800);
    }
    else
    {
        wanted_result_control_part_proc_shoot(win_set);
    }

}

function wanted_anim_flip(symbol, x, y)
{
    symbol = "symbol_" + symbol;
    var old = madnes_get_texture("reels_bufer_" + x + "_TMP" + y, symbol);
    madnes_set_texture("reels_bufer_" + x + "_TMP" + y, symbol);
    for(var anim in icons[symbol])
    {
        madnes_anim_add("reels_bufer_" + x + "_TMP" + y, anim, icons[symbol][anim]);

        if(anim == "anim_reverse")
        {
            madnes_anim_add_oncomplete(
                "reels_bufer_" + x + "_TMP" + y,
                wanted_anim_flip_back.bind(this, old, x, y )
            );
        }

    }
    madnes_anim_play("reels_bufer_" + x + "_TMP" + y, "anim");
}

function wanted_anim_flip_back(symbol, x, y)
{
    madnes_set_texture("reels_bufer_" + x + "_TMP" + y, symbol);
    for(var anim in icons[symbol])
    {
        madnes_anim_add("reels_bufer_" + x + "_TMP" + y, anim, icons[symbol][anim]);
    }
    madnes_anim_play("reels_bufer_" + x + "_TMP" + y, "flip_back");
}

// Prustrel vyhry
function wanted_result_control_part_proc_shoot(win_set)
{
    // Caru -> zvuk -> zabarvit -> otocit -> (prostrelit) -> otocit zpet -> posunout
    if(win_set.type == "normal" && (win_set.symbol == 7 || win_set.symbol == 9))
    {
        setTimeout(function() {
            wanted_hide_lines();
            result_control_pos++;
            wanted_result_control_part();
        }, 200);
    }
    else
    {
        if(wanted_show_win_sum_animated == 1)
        {
            setTimeout(wanted_result_control_part_proc_shoot.bind(this, win_set), 1000 / fps);
            return;
        }

        var delay = 150;
        var inpos = 0;

        wanted_show_win_sum_start(win_set);

        for(var pos in win_set.position)
        {
            (function(pos, inpos) {
                setTimeout(wanted_bullet_show.bind(null, win_set.position[pos][1] + 1, win_set.position[pos][0] + 1), delay * inpos);
            }(pos, inpos));

            inpos++;
        }

        setTimeout(wanted_result_control_part_proc_shoot_back.bind(null, win_set), delay * (inpos + 1));
    }
}

// Nacasovani skryti prustrelu
export function wanted_result_control_part_proc_shoot_back(win_set)
{
    setTimeout(wanted_bullets_hide, Math.random()*400);
    wanted_result_control_part_proc_trn_back(win_set);
}

// Navrat symbolu
function wanted_result_control_part_proc_trn_back(win_set)
{

    // Caru -> zvuk -> zabarvit -> otocit -> prostrelit -> (otocit zpet) -> posunout
    if(win_set.type == "wild")
    {
        var wilds = new Array();
        for(var wld in server_result.result.gameSpecifics.wildPositions)
        {
            var x_tmp = server_result.result.gameSpecifics.wildPositions[wld][0];
            var y_tmp = server_result.result.gameSpecifics.wildPositions[wld][1];
            if(wilds[x_tmp] == null)
            {
                wilds[x_tmp] = new Array();
            }
            wilds[x_tmp][wilds[x_tmp].length] = y_tmp;
        }

        for(var pos in win_set.position)
        {
            if(wilds[win_set.position[pos][0]] != null)
            {
                if(wilds[win_set.position[pos][0]].indexOf(win_set.position[pos][1]) != -1)
                {
                    var symbol = picture_convert[win_set.symbol];
                    symbol = symbol.split("_");
                    symbol = symbol[1];

                    //madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ), "wild_symbol_" + symbol + "_back")
                    madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "anim_reverse")

                    //madnes_audio_play("WILD_FLIP_BACK");// ODEBRANO 20170524
                }
            }
        }
        setTimeout(function() {
            wanted_result_control_part_proc_nxt(win_set);
        }, 100);
    }
    else
    {
        wanted_result_control_part_proc_nxt(win_set);
    }
}

// Konec animace -> prejit na kontrolu dalsi (pouze nacasovani)
function wanted_result_control_part_proc_nxt(win_set)
{
    // Caru -> zvuk -> zabarvit -> otocit -> prostrelit -> otocit zpet -> (posunout)

    setTimeout(function() {
        wanted_hide_lines();
        result_control_pos++;
        wanted_result_control_part();
    }, 1000);
}


var win_anim_played = false;

// Zacatek kontroly pridavani penez
function wanted_money_add_control()
{
    set_inwincount(false); // inwincount = false;

    madnes_win_anim_reset();
    // madnes_show_stop();

    if(!win_anim_played && win * 1 > 0)
    {
        wanted_money_add_win( madnes_money_to_coin( win ));
        //madnes_audio_loop('remittance_A');
    }
    else
    {
        setTimeout(madnes_audio_stop.bind(null, 'remittance_A'), 200);
        // MS EDGE audio fix
        //madnes_audio_continue('BACKGROUND');
        setTimeout(function () {
            if (!madnes_audio_is_playing('BACKGROUND')) {
                madnes_audio_loop('BACKGROUND');
            }
        }, 100);
        // MS EDGE audio fix end

        // var ended = true;
        // if(freespinsData) {
        //     ended = freespinsData.ended;
        // }
        //
        // madnes_end_round(ended, {}, freespinsData, function() {
        //
        //     // madnes_show_btns();
        //     end_result_control();
        //
        // });

        madnes_end_round();
    }
}

export function wanted_end_round_recalced()
{
    set_inwincount(false); //inwincount = false;
    set_inmoneyadd(false); // inmoneyadd = 0;
    set_inanim(false); // inanim = 0;
    win_anim_played = false;

    // // madnes_on_end_round_recount(win);
    // // madnes_on_round_end();
    // // madnes_recount_bet();
    //
    autospin_force_enabled = false;
    // if(is_in_autostart() || autospin_force)
    // {
    //     autospin_force = false;
    //     madnes_rotate_start();
    // }
}

function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}

export var fromsaloon = 0; // Prichazime ze saloonu? nebude vybuch
export function set_fromsaloon(bool) {
    fromsaloon = bool;
}


var boom_digits = 0; // pocet cislic pri vybuchu
var boom_ready = 0;  // je vybuch dokoncen / pripraven pro vypisovani cislic
export function set_boom_ready(bool) {
    boom_ready = bool;
}

var boom_sum = 0;   // aktualni suma na papire vybuchu

var moneyadd_pos = 0;
var moneyadd_dir = 0;
var money_add_win_speed = 18;

function wanted_money_add_win(max)
{
    if(inmoneyadd == 0 && inbigwin == 0 && (
        fromsaloon == 0 ||
        (
            typeof server_result != "undefined" &&
            typeof server_result.result != "undefined" &&
            typeof server_result.result.freeSpinNumber != "undefined" &&
            server_result.result.freeSpinNumber > 0
        )
    )
    )
    {
        if(
            max * 1 > bet * 1 * big_win ||
            (
                typeof server_result != "undefined" &&
                typeof server_result.result != "undefined" &&
                typeof server_result.result.freeSpinNumber != "undefined" &&
                server_result.result.freeSpinNumber > 0
            )
        )
        {
            wanted_money_add_big_win(max);
            return;
        }

        set_inmoneyadd(true); // inmoneyadd = 1;
    }

    win_anim_played = true;

    madnes_show_money(max, function() {
        wanted_money_add_control();
        set_inmoneyadd(0); // inmoneyadd = 0;
    });


    set_inbigwin(0); // inbigwin = 0;
    fromsaloon = 0;
}

// var wanted_freespins_data = null;
function wanted_money_add_big_win(max /*, freespins_data*/)
{
    states.setState(STATES.BONUS_WIN);

    // wanted_freespins_data = freespins_data;

    //madnes_start_coin();
    boom_digits = max.toString().length;
    boom_ready = 0;
    boom_sum = 0;
    set_inbigwin(1); // inbigwin = 1;
    wanted_boom_start();
    setTimeout(wanted_money_add_big_win_anim.bind(null, max), 1000 / 60);
}

function wanted_money_add_big_win_anim(max)
{
    if(boom_ready == 0)
    {
        setTimeout(wanted_money_add_big_win_anim.bind(null, max), 1000 / 60);
    }
    else
    {
       boom_sum += Math.random() * max % (max / 50) + (max / 100);
        // boom_sum = boom_sum * 1 + Math.random() * max % (max / 50) + (max / 100);

        if(boom_sum < 1) {
            boom_sum = 1;
        }

        if(boom_sum * 1 > max * 1)
        {
            boom_sum = max;
        }

        var sum_str = (boom_sum | 0).toString();

        madnes_set_text("boom_num", sum_str);

        if(boom_sum * 1 < max * 1)
        {
            setTimeout(wanted_money_add_big_win_anim.bind(null, max), 100);
        }
        else
        {
            if(
                typeof server_result != "undefined" &&
                typeof server_result.result != "undefined" &&
                typeof server_result.result.freeSpinNumber != "undefined" &&
                server_result.result.freeSpinNumber > 0 &&
                max != madnes_money_to_coin( server_result.result.totalWin )
            )
            {
                madnes_audio_stop('remittance_A');
                set_wanted_snake_desk_step(0); //wanted_snake_desk_step = 0;
                set_wanted_snake_desk_pos(0); //wanted_snake_desk_pos = 0;
                set_wanted_snake_desk_dir(1); //wanted_snake_desk_dir = 1;

                madnes_set_pos("x2", wi / 2, he / 2);
                madnes_set_img_center("x2", -0.4, -0.5);
                madnes_set_angle("x2", -20);
                madnes_set_alpha("x2", 0);
                setTimeout(function(){madnes_alpha_to("x2", 1, 200);},100);
                madnes_set_scale("x2", 5, 5);
                madnes_scale_to("x2", 1.0, 1.0, 400, function()
                {
                    wanted_shake_desk();

                    setTimeout(function()
                    {
                        madnes_audio_play("FS_whip");
                    }, 100);
                    madnes_scale_to("x2", 1.2, 1.2, 300, function()
                    {
                        madnes_scale_to("x2", 1, 1, 200, function()
                        {
                            madnes_scale_to("x2", 1, 1, 300, function() {
                                madnes_set_win(win * 2);
                            });
                        });
                    });
                });
                //madnes_audio_play("FS_whip");

                max = madnes_money_to_coin( server_result.result.totalWin );
                setTimeout(function () {
                    wanted_money_add_big_win_anim(max);
                    madnes_audio_loop('remittance_A');
                }, 1000 / fps);
                return;
            }

            set_wanted_snake_desk_step(0); //wanted_snake_desk_step = 0;
            set_wanted_snake_desk_pos(0); //wanted_snake_desk_pos = 0;
            set_wanted_snake_desk_dir(1); //wanted_snake_desk_dir = 1;

            /*
            main_phaser.world.pivot.x = wi/2 * wi_scale;
            main_phaser.world.pivot.y = he/2 * he_scale;
            main_phaser.world.setBounds(-wi/2 * wi_scale, -he/2 * he_scale, wi * wi_scale, he * he_scale);
            */

            madnes_audio_stop('remittance_A');
            //madnes_audio_play('BIG_WIN');
            /*
            wanted_shake_desk();
            */
            madnes_scale_to("big-win_Money", 1.15, 1.15, 100,function()
                {
                    madnes_scale_to("big-win_Money", 1, 1, 200);
                }
            );
            madnes_scale_to("big-win_Paper", 1.15, 1.15, 100,function()
                {
                    madnes_scale_to("big-win_Paper", 1, 1, 200);
                }
            );
            madnes_scale_to("big-win_Text-1", 1.15, 1.15, 100,function()
                {
                    madnes_scale_to("big-win_Text-1", 1, 1, 200);
                }
            );
            madnes_scale_to("boom_num", 1.15, 1.15, 100,function()
                {
                    madnes_scale_to("boom_num", 1, 1, 200);
                }
            );
            madnes_scale_to("x2", 1.15, 1.15, 100,function()
                {
                    madnes_scale_to("x2", 1, 1, 200);
                }
            );

            wanted_vibrate(200);

            setTimeout(wanted_boom_end, 4000);
            //setTimeout("madnes_audio_loop('remittance_A'); wanted_money_add_win("+max+")", 4100);


            win_anim_played = true;

            moneyadd_pos = 0;
            moneyadd_dir = 0;

            set_inmoneyadd(0); //inmoneyadd = 0;
            set_inbigwin(0); // inbigwin = 0;
            fromsaloon = 0;

            setTimeout(wanted_money_add_control.bind(null), 4100);

            //madnes_stop_coin();
        }
    }
}
// Konec kontroly penez

export function wanted_vibrate(times)
{
    return;
    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
    if(navigator.vibrate)
    {
        navigator.vibrate(times);
    }
}


function get_fs_end_data(fs_pos) {

    if(!server_result['result']['freeSpinResults']) {
        return {};
    }

    var _fs_win = 0;
    var _fs_res = server_result['result']['freeSpinResults'];

    if(fs_pos <= 0) {
        _fs_win = wanted_get_linewins_win_sum(server_result.result);
    } else {
        _fs_win = wanted_get_linewins_win_sum(_fs_res[fs_pos - 1]['result']);
    }

    return {
        "ended": server_result.result.freeSpinResults.length == fs_pos,
        "win": _fs_win,
        "order": fs_pos,
        "count": server_result.result.freeSpinResults.length
    }
}